<template>
  <div>
    <div class="wd-mb-6">
      <p class="wd-text-base !wd-mb-0">{{ $t('create_account_cancel_model_title') }}</p>
    </div>

    <div class="wd-flex wd-gap-3 wd-w-full">
      <v-btn class="wd-w-1/2 wd-text-lg wd-bg-gray20" height="40" variant="text" @click="handleCancel">{{ $t('all_back') }}</v-btn>
      <v-btn class="wd-w-1/2 wd-text-lg" height="40" color="orange50" variant="flat" @click="handleConfirm">
        {{ $t('create_account_cancel_modal_cancel_button') }}
      </v-btn>
    </div>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  (e: 'confirm'): void
  (e: 'cancel'): void
}>()

const handleConfirm = () => {
  emit('confirm')
}

const handleCancel = () => {
  emit('cancel')
}
</script>
